import { Fragment } from 'react';

import { Accordion, Box, Text } from '@zillow/constellation-10';

import FeedOverrideSectionSyncingBanner from '../FeedOverrideSectionSyncingBanner';
import FeedOverridesSwitch from './FeedOverridesSwitch';

import type { TagPropsInterface } from '@zillow/constellation-10';
import type { FeedOverrideSection } from '@zg-rentals/ts-rental-manager-api-client';

type AccordionTag = React.ReactElement<TagPropsInterface>;

type AccordionContentContainerProps = {
  content: React.ReactNode;
  header?: React.ReactNode;
  /** Pass an array to render several tags side by side; a single element renders on its own. */
  tag?: AccordionTag | Array<AccordionTag> | null | undefined;
  /** Renders next to the header text instead of in the tag row. */
  headerTag?: AccordionTag;
  id?: string | null;
  eventId?: string;
  accordionIndex: number;
  isFeed?: boolean;
  feedOverrideSection?: FeedOverrideSection;
};
/*
 * NOTE: This component is to be used with `Accordion.Root` from `@zillow/constellation-10`
 */
const AccordionContentContainer = ({
  content,
  header = '',
  tag = null,
  headerTag,
  id = null,
  eventId,
  accordionIndex,
  isFeed = false,
  feedOverrideSection,
}: AccordionContentContainerProps) => {
  return (
    <Accordion.Item
      value={accordionIndex.toString()}
      id={id ?? undefined}
      data-eventid={eventId}
      data-accordion-index={accordionIndex}
    >
      <Accordion.Header>
        <Box css={{ display: 'flex', alignItems: 'center', gap: '200' }}>
          <Text textStyle="body-bold">{header}</Text>
          {headerTag}
        </Box>
        {Array.isArray(tag)
          ? tag.length > 0 && (
              <Box css={{ display: 'flex', alignItems: 'center', gap: '200' }}>
                {tag.map((accordionTag, index) => (
                  <Fragment key={accordionTag.key ?? index}>{accordionTag}</Fragment>
                ))}
              </Box>
            )
          : tag}
      </Accordion.Header>
      <Accordion.Panel>
        {isFeed && feedOverrideSection && (
          <>
            <FeedOverridesSwitch section={feedOverrideSection} />
            <FeedOverrideSectionSyncingBanner />
          </>
        )}
        {content}
      </Accordion.Panel>
    </Accordion.Item>
  );
};

export default AccordionContentContainer;
